import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDocumentslist } from "../../../StateManagement/Reducers/DocumentsState";

import { Div, PageTitle, Button, Text } from "../../StyledComponents";
import { IoMdArrowForward } from "react-icons/io";
import { FiFileText } from "react-icons/fi";

const DocumentsPreview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const DocumentsList = useSelector(
    (state) => state.Document?.Documentlist || [],
  );

  useEffect(() => {
    dispatch(getDocumentslist({ filtertype: "New Documents" }));
  }, [dispatch]);

  return (
    <Div
      gridArea="Documents"
      width="100%"
      height="auto"
      minHeight="220px"
      backColor="#ffffff"
      padding="16px"
      borderRadius="8px"
      border="1px solid #d8e0f0"
    >
      <Div display="flex" margin="0 0 20px 0">
        <PageTitle fontSize="24px">Documents</PageTitle>
        <Button
          background="none"
          border="none"
          marginLeft="auto"
          padding="0"
          height="auto"
          display="flex"
          alignItems="center"
          onClick={() => navigate("/Documents")}
        >
          <Text color="#407BFF" fontWeight="600">
            View All →
          </Text>
        </Button>
      </Div>

      {DocumentsList && DocumentsList.length > 0 ? (
        DocumentsList.slice(0, 5).map((doc, index, arr) => (
          <Div
            key={doc.id}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="12px 0"
            borderBottom={
              index !== arr.length - 1 ? "1px solid #F2F4F7" : "none"
            }
          >
            <Div display="flex" alignItems="flex-start" gap="10px">
              <Div
                width="34px"
                height="34px"
                minWidth="32px"
                borderRadius="16px"
                background="#F2F4F7"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FiFileText size={16} color="#407BFF" />
              </Div>

              <Div display="flex" flexDirection="column">
                <Text fontWeight="600" fontSize="13px" color="#344054">
                  {doc.form_name}
                </Text>

                <Text color="#98A2B3" fontSize="12px">
                  {doc.date}
                </Text>
              </Div>
            </Div>

            <Div
              background={
                doc.status === "New"
                  ? "rgba(0,165,255,0.1)"
                  : doc.status === "In Review"
                    ? "rgba(32,201,172,0.1)"
                    : "rgba(132,129,138,0.1)"
              }
              color={
                doc.status === "New"
                  ? "#00a5ff"
                  : doc.status === "In Review"
                    ? "#20c9ac"
                    : "#2e2c34"
              }
              padding="4px 10px"
              borderRadius="6px"
              fontSize="12px"
              fontWeight="600"
            >
              {doc.status}
            </Div>
          </Div>
        ))
      ) : (
        <Text color="#98A2B3">No Documents Found</Text>
      )}
    </Div>
  );
};

export default DocumentsPreview;
